export const Loader = ({colSpan = 1}) => (
  <tr className="data-list no_result">
    <td colSpan={colSpan} className="text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    </td>
  </tr>
)
